import React, { useEffect, useRef, useState } from 'react'
import {Grid, Box, Paper, Typography, Container, Button, Stack, Avatar, 
    Select, MenuItem,
    RadioGroup, FormControl, FormLabel, FormControlLabel, Radio,
    TextField, 
    TableRow, TableCell,
    ButtonGroup
} from '@mui/material'
import Tab from '@mui/material/Tab';
import TabContext from '@mui/lab/TabContext';
import TabList from '@mui/lab/TabList';
import TabPanel from '@mui/lab/TabPanel';
import { List, ListItem, ListItemText, ListItemButton, CircularProgress } from '@mui/material';
import Api from '../Services/Api';
import StaticVar from '../Config/StaticVar';

import { Html5Qrcode } from 'html5-qrcode';
import QrReader from 'react-qr-reader';

export default function LoginPage() {
  const [scanResult, setScanResult] = useState('');
  const [loginData, setLoginData] = useState({});
  const [loading, setLoading] = useState(false);
  const [errorText, setErrorText] = useState('');
  const [passCodeResult, setPassCodeResult] = useState('');
  // const qrCodeRegionId = 'qr-reader';
  // const html5QrCodeRef = useRef(null);

  // useEffect(() => {
  //   const qrCodeScanner = new Html5Qrcode(qrCodeRegionId);
  //   let isScannerActive = true
  //   const startScanner = async () => {
  //     try {
  //       await qrCodeScanner.start(
  //         { facingMode: 'environment' },
  //         {
  //           fps: 10,
  //           qrbox: { width: 500, height: 500 }
  //         },
  //         async (decodedText, decodedResult) => {
  //           if (!isScannerActive) return;
  //           console.log('decodedResult', decodedText, decodedResult);
  //           isScannerActive = false;
            
  //           try {
  //             const response = await Api.postAuthLogin({ passcode: decodedText });
  //             setLoginData(response);
  //             localStorage.setItem('token', response.token);
  //             await qrCodeScanner.stop();
  //             window.location.href = '/app';
  //           } catch (err) {
  //             console.error('Login error:', err);
  //             isScannerActive = true; // allow retry
  //           }
  //         },
  //         (errorMessage) => {
  //           // console.warn('Scanning error:', errorMessage); // optional: silent
  //         }
  //       );
  //       html5QrCodeRef.current = qrCodeScanner;
  //     } catch (err) {
  //       console.error('QR Code start failed:', err);
  //     }
  //   };

  //   startScanner();

  //   return () => {
  //     if (html5QrCodeRef.current) {
  //       html5QrCodeRef.current.stop().then(() => {
  //         html5QrCodeRef.current.clear();
  //       });
  //     }
  //   };
  // }, []);

  const handlePassCode = async (passcode) => {
   const response = await Api.getCode({ passcode });
   console.log('response getCode', response);
   handleScan(response)
  }

  const handleScan = async (data) => {
    if (data && !loading) {
      setScanResult(data);
      setLoading(true);
      setErrorText('');

      try {
        const response = await Api.postAuthLogin({ passcode: data });
        setLoginData(response);
        localStorage.setItem('token', response.token);
        window.location.href = '/app';
      } catch (error) {
        setErrorText('Login gagal. QR tidak valid.');
        setLoading(false);
      }
    }
  };

  const handleError = (err) => {
    console.error('QR Scan Error:', err);
    setErrorText('Gagal mengakses kamera.');
  };
  
  useEffect(() => {
  document.body.style.backgroundColor = '#000';
  document.body.style.color = '#fff'; // agar teks bisa terlihat

  return () => {
    // reset jika keluar dari halaman ini
    document.body.style.backgroundColor = '';
    document.body.style.color = '';
  };
}, []);
  return (
    <Container maxWidth="xl"  sx={{p:1}}>

      {/* <ButtonGroup variant="contained" aria-label="Basic button group">
        <Button>One</Button>
        <Button>Two</Button>
        <Button>Three</Button>
      </ButtonGroup> */}
      <center>
        {/* <Paper elevation={3} sx={{p:2}}> */}
            {/* <Typography>Login Page</Typography>
            <h2>Silahkan Scan Kode QR untuk membuka panel penguji</h2>
            <div id={qrCodeRegionId} style={{ width: '500px', margin: 'auto' }}></div>
            {scanResult && (
                <div style={{ marginTop: '20px' }}>
                <strong>Hasil Scan:</strong> {scanResult}
                <strong>Hasil Login:</strong> {JSON.stringify(loginData)}
                </div>
            )} */}

            <Typography variant="h5">Login Page</Typography>
            <Typography variant="body1" gutterBottom>
              Silahkan Scan Kode QR untuk membuka panel penguji
            </Typography>

            <div style={{ width: '500px', margin: 'auto' }}>
              <QrReader
                // constraints={{ facingMode: 'environment' }}
                delay={300}
                onError={handleError}
                onScan={handleScan}
                style={{ width: '100%' }}
              />

              {/* <QrReader
                constraints={{ facingMode: 'environment' }}
                onResult={(result, error) => {
                  if (!!result) handleScan(result.getText());
                }}
                style={{ width: '100%' }}
              /> */}
            </div>

            {loading && <CircularProgress sx={{ mt: 2 }} />}
            {scanResult && !loading && (
              <div style={{ marginTop: 20 }}>
                <strong>Hasil Scan:</strong> {scanResult}
              </div>
            )}
            {errorText && (
              <div style={{ color: 'red', marginTop: 10 }}>
                {errorText}
              </div>
            )}

            <Box backgroundColor="#fff" color="#000" sx={{ display: 'inline-block', p: 2, mt: 4, borderRadius: 2 }}>
            <Typography variant="body2" sx={{ mt: 2 }}>Input Passcode : </Typography>
              <TextField
                variant="outlined"
                value={passCodeResult}
                onChange={(e) => setPassCodeResult(e.target.value)}
                disabled={loading}
                sx={{ mt: 1, width: '300px', textAlign: 'center' }}
              />
              <br/>
              <Button
                variant="contained"
                onClick={() => handlePassCode(passCodeResult)}
                disabled={loading || !passCodeResult}
                sx={{ ml: 2, mt: 1 }}
              >
                Submit
              </Button>
            </Box>
        </center>
        {/* </Paper> */}
    </Container>
  )
}
